var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.0001 18.9801C10.7701 18.9801 10.5501 18.9001 10.3601 18.7501L4.36009 13.7501C3.94009 13.4001 3.88009 12.7701 4.23009 12.3401C4.58009 11.9201 5.21009 11.8601 5.64009 12.2101L10.9001 16.6001L20.2601 6.31015C20.6301 5.90015 21.2701 5.87015 21.6701 6.24015C22.0801 6.61015 22.1101 7.24015 21.7401 7.65015L11.7401 18.6501C11.5401 18.8701 11.2701 18.9801 11.0001 18.9801Z",
  fill: "inherit"
})));
export default SvgCheck;